import classNames from "classnames";
import { styleWithVars } from "@lib/cssVars";
import styles from "./DensityChart.module.scss";

interface DensityChartTracksProps {
    count: number;
    /** From `BAR_GAP_SHARE`, so the tracks line up with the bars. */
    gapShare: number;
    className?: string;
    /** Each track also gets `--track-index`, and the row `--track-count`, e.g. for a staggered entrance. */
    trackClassName?: string;
    /** The track hovered off its bar's segments, drawn darker. */
    hoveredIndex?: number;
}

/** A row of full-height bar tracks filling its container, one per bar on the chart's pitch. */
export function DensityChartTracks({
    count,
    gapShare,
    className,
    trackClassName,
    hoveredIndex,
}: DensityChartTracksProps) {
    return (
        <div
            className={classNames(styles.tracks, className)}
            style={styleWithVars({
                "--bar-gap-share": gapShare,
                "--track-count": count,
            })}
            aria-hidden
        >
            {Array.from({ length: count }, (_, index) => (
                <div
                    key={index}
                    className={classNames(styles.track, trackClassName)}
                    style={styleWithVars({ "--track-index": index })}
                    data-hovered={index === hoveredIndex || undefined}
                />
            ))}
        </div>
    );
}
